export const DARK_THEME = 'dark';
export const LIGHT_THEME = 'light';
export const NO_THEME = 'NONE';



// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/themes/common/constants.js